//Imports
import './App.css';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import React from 'react';

//Import Pages for routing
import Start from "./frontend/pages/start"
import Intern from "./frontend/pages/intern/internstart"
import Internlogin from "./frontend/pages/intern/internlogin"
import Timpage from "./frontend/pages/intern/people/tim/timpage";
import Internsettings from "./frontend/pages/intern/internsettings";
import Updatelog from "./frontend/pages/intern/updatelog";
import Internhilfe from "./frontend/pages/intern/internhilfe";
import Omipage from './frontend/pages/intern/people/omi/omipage';
import Klosterspage from './frontend/pages/intern/people/klosters/klosterspage';

//Function App

function App() { //Routing -> Nothing else then routing in here!

  return (

      <Router>
        <Routes>

          <Route exact path ="/" element={<Start/>}></Route>

            {
                //Routes Intern
            }

            <Route exact path="/internstart" element={<Intern/>}></Route>
            <Route exact path="/intern/login" element={<Internlogin/>}></Route>
            <Route exact path={"/intern/settings"} element={<Internsettings/>}></Route>
            <Route exact path={"/intern/settings/updatelog"} element={<Updatelog/>}></Route>
            <Route exact path={"/intern/settings/hilfe"} element={<Internhilfe/>}></Route>

                {
                //Routes Intern People
                }
           <Route exact path="/intern/people/tim" element={<Timpage/>}> </Route>
            



            <Route exact path="/intern/people/omi" element={<Omipage/>}></Route>
            <Route exact path='/intern/people/klosters' element={<Klosterspage/>}></Route>


        </Routes>

      </Router>

  );
}

export default App;
